import { render, staticRenderFns } from "./SpbCeoForADay.vue?vue&type=template&id=2631bb9b&scoped=true&"
import script from "./SpbCeoForADay.vue?vue&type=script&lang=js&"
export * from "./SpbCeoForADay.vue?vue&type=script&lang=js&"
import style0 from "./SpbCeoForADay.vue?vue&type=style&index=0&id=2631bb9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2631bb9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VContainer,VFadeTransition,VIcon,VImg,VRow,VSimpleTable,VTooltip})
